/* Important Info component on the SceneCreateForm
   telling users that Scene Numbers can never be changed */
import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import styles from "../../../styles/Scene.module.css";

const ImportCreate = () => {
  return (
    <div>
    <Row className="mb-3">
      <Col className="d-none d-md-block" md={1}></Col>     
      <Col xs={12} md={10} >
      <div className={` px-3 pt-1 ${styles.SubTitle6 }`}>
      <p className={`${styles.Red} text-center`}>IMPORTANT - SCENE NUMBERS</p>
      <hr className={`mt-2 mb-0`}/>
      <p className="pt-2" ><span className={`${styles.Red}`}>*</span> A Scene should be created for every<span className={`${styles.Red}`}> Heading</span> in the Script
        and given a Number.</p>
      <p className="pt-2"><span className={`${styles.Red}`}>*</span> Script sequences that have <span className={`${styles.Red}`}>more than one location</span> but are to be consider as one Scene, e.g.,
          phone calls, montages or some intercuts, can be given a new number, numbered with a decimal, e.g., 7.2, similar to "Scenes between Scenes - see below, or just noted 
          in the Breakdown "Story/Editing" field.
      </p>
      <p className="pt-2" ><span className={`${styles.Red}`}>*</span> The <span className={`${styles.Red}`}>Heading Info</span> field in the Breakdown should be used to denote 
        Intercuts, Montages, Continuous etc.</p>
      <p className="pt-2" ><span className={`${styles.Red}`}>*</span> The Scenes and their Numbers should <span className={`${styles.Red}`}>match</span> in the Platform, 
      Script and Shooting Script.</p>
      <p className={`pt-2`}><span className={`${styles.Red}`}>*</span> To add new <span className={`${styles.Red}`}>Scenes between Scenes</span> use decimals, see below.</p>
      <div className="pl-5">
      <hr/>
      <Row>
      <Col xs={4}>
      <p>
      Scene between
      </p>
      <p>
      Scene between
      </p>
      <p>
      Scene between
      </p>
      </Col>
      <Col xs={2}>
      <p>
      7
      </p>
      <p>
      7
      </p>
      <p>
      7
      </p>
      </Col>
      <Col xs={2}>
      <p>
      and
      </p>
      <p>
      and
      </p>
      <p>
      and
      </p>
      </Col>
      <Col xs={2}>
      <p>
      8
      </p>
      <p>
      7.5
      </p>
      <p>
      7.25
      </p>      
      </Col>
      <Col xs={2}>
      <p>
      7.5
      </p>
      <p>
      7.25
      </p>
      <p>
      7.125
      </p>       
      </Col>
      </Row>
      <hr/>
      <p>
      This can go on indefinitely, 7.06, 7.03, 7.015, 7.005 etc.
      </p>
      </div>
      <hr className={`mt-2 mb-0`}/>
      </div>
      </Col>
    </Row>
    </div>
  )
}

export default ImportCreate